import { render, staticRenderFns } from "./Ident.vue?vue&type=template&id=4edfd5f4"
import script from "./Ident.vue?vue&type=script&lang=ts"
export * from "./Ident.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports